module.exports = __webpack_public_path__ + "static/img/video-popup-bg-2-1-300x164.b55f1ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/video-popup-bg-2-1-300x164.jpg
// module id = aP7I
// module chunks = 0